import React, { Component } from 'react'

// ui
import Modal from '../../components/feedback/modal'
import Button from '../../components/uielements/button'

// redux
import { connect } from 'react-redux'
import objectActions from '../../redux/object/actions'

class ModalConfirmDelete extends Component {
    _handleOK = () => {
        this.props.dismiss()
        this.props.deleteObject(this.props.object.object_id)
    }

    _handleCancel = () => {
        this.props.dismiss()
    }

    render() {
        const { visible } = this.props
        return (
            <Modal
                visible={visible}
                title="Xác nhận xoá đối tượng"
                onOk={() => this._handleOK()}
                onCancel={() => this._handleCancel()}
                centered
                footer={[
                    <Button 
                        style={{ backgroundColor: '#b3e6ff' }}
                        onClick={() => this._handleCancel()}
                    >
                        Không
                    </Button>,
                    <Button
                        style={{ backgroundColor: '#ff9999' }}
                        onClick={() => this._handleOK()}
                    >
                        Xoá
                    </Button>,
                ]}
            >
                <p>Bạn có chắc chắn đối tượng này không?</p>
            </Modal>
        )
    }
}

const mapStateToProps = state => {
    return {
        visible: state.object.modalConfirmDeleteObjectState,
        object: state.object.currentObject
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dismiss: () => {
            dispatch(objectActions.action.dismissModalConfirmDeleteObject())
        },
        deleteObject: (objectId) => {
            dispatch(objectActions.action.deleteObject(objectId))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ModalConfirmDelete)
